import AlbumSearchResult from './AlbumSearchResult';

export default AlbumSearchResult;
